module.exports = __webpack_public_path__ + "img/input-symbol-error.158a9a91.svg";